import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
import { ref, watch, nextTick } from '../../../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { getBoundingClientRectSync } from '@tencentcloud/universal-api';
import { convertor } from '../../../utils/convertVoiceToText';
export default /*@__PURE__*/_defineComponent({
  __name: 'convert-content',
  props: {
    message: {
      default: () => ({})
    },
    contentVisible: {
      type: Boolean
    },
    convertWrapperRef: {},
    isSingleConvert: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggleErrorStatus"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var convertFinished = ref(false);
    var convertText = ref('');
    var calculateHeight = ref(0);
    var calculateWidth = ref(0);
    var convertLoadingRef = ref();
    var convertContentRef = ref();
    watch(() => props.contentVisible, newVal => {
      if (newVal) {
        convertor.get(props.message).then(text => {
          convertFinished.value = true;
          convertText.value = text;
          nextTick(() => {
            var {
              height: originHeight,
              width: originWidth
            } = getBoundingClientRectSync(convertLoadingRef.value);
            var {
              height,
              width
            } = getBoundingClientRectSync(convertContentRef.value);
            calculateHeight.value = originHeight;
            calculateWidth.value = originWidth;
            requestAnimationFrame(() => {
              calculateHeight.value = height;
              calculateWidth.value = width;
              if (props.isSingleConvert) {
                nextTick(() => {
                  var {
                    bottom
                  } = getBoundingClientRectSync(props.convertWrapperRef);
                  var {
                    bottom: bottomWindow
                  } = getBoundingClientRectSync('#messageScrollList');
                  if (bottom > bottomWindow) {
                    var timer = setTimeout(() => {
                      props.convertWrapperRef.scrollIntoView({
                        block: 'end',
                        behavior: 'smooth'
                      });
                      clearTimeout(timer);
                    }, 150);
                  }
                });
              }
            });
          });
        }).catch(err => {
          convertFinished.value = true;
          emits('toggleErrorStatus', true);
          var {
            height: originHeight
          } = getBoundingClientRectSync(convertLoadingRef.value);
          calculateHeight.value = originHeight;
          convertText.value = err.message;
        });
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "message-convert-container",
        style: _normalizeStyle({
          height: _unref(calculateHeight) > 0 ? "".concat(_unref(calculateHeight), "px") : 'auto',
          width: _unref(calculateWidth) > 0 ? "".concat(_unref(calculateWidth), "px") : 'auto'
        })
      }, [_unref(convertFinished) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "convertContentRef",
        ref: convertContentRef,
        class: _normalizeClass({
          'convert-content': true,
          'occur': _unref(calculateHeight) > 0
        })
      }, _toDisplayString(_unref(convertText)), 3)) : _createCommentVNode("", true), _createElementVNode("div", {
        ref_key: "convertLoadingRef",
        ref: convertLoadingRef,
        class: _normalizeClass({
          'loading': true,
          'loading-end': _unref(convertFinished)
        })
      }, _toDisplayString(_unref(TUITranslateService).t('TUIChat.转换中')) + "... ", 3)], 4);
    };
  }
});